// GA4 loader — activates only when REACT_APP_GA4_ID is set (GA-ready).
const GA_ID = process.env.REACT_APP_GA4_ID;

export function initGA() {
  if (!GA_ID || typeof window === "undefined" || window.__gaLoaded) return;
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () { window.dataLayer.push(arguments); };
  window.gtag("js", new Date());
  window.gtag("config", GA_ID, { send_page_view: false });
  window.__gaLoaded = true;
}

export function trackPageView(path, title) {
  if (!GA_ID || typeof window === "undefined" || !window.gtag) return;
  window.gtag("event", "page_view", {
    page_path: path,
    page_title: title,
    page_location: window.location.href,
  });
}

// Generic GA4 event (used for the lead-form conversion).
export function trackEvent(name, params = {}) {
  if (!GA_ID || typeof window === "undefined" || !window.gtag) return;
  window.gtag("event", name, params);
}
